// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ac209a7","732":"38b78b4d","977":"27e2b5cd"}[chunkId] + ".chunk.js";
};